import { gql } from '@apollo/client';

export const MUTATION_ERROR_FRAGMENT = gql`
  fragment ErrorFields on Error {
    code
    field
    message
  }
`;
